import NewLogoWithOmny from "@/components/brand_elements/NewLogoWithOmny.vue";
export default {
  name: "LogoWithDescription",
  components: {
    NewLogoWithOmny
  }
};